import theme from './theme/reducer';

export default {
  theme,
};
